import React from 'react';
import type { ProjectKey } from '@atlassian/jira-common-navigation/src/get-scope-data/types.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import OpTrigger from '@atlassian/jira-common-util-op-triggers/src/on-mount/index.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';

type Props = {
	baseUrl: BaseUrl;
	projectKey: ProjectKey;
};

export const addProjectToHistory = (baseUrl: BaseUrl, projectKey: ProjectKey) =>
	performPostRequest(`${baseUrl}/rest/internal/2/project/${projectKey}/recent`).catch((e) => {
		log.safeErrorWithoutCustomerData(
			'spa-apps.common.src.add-project-to-history',
			'Cannot set recent project',
			e,
		);
	});

const AddProjectToHistory = ({ baseUrl, projectKey }: Props) => (
	<OpTrigger op={() => addProjectToHistory(baseUrl, projectKey)} />
);

export default AddProjectToHistory;
